const mapTileProvider = (x: number, y: number, z: number): string => {
  const s = String.fromCharCode(97 + ((x + y + z) % 3));
  return `https://${s}.tile.openstreetmap.org/${z}/${x}/${y}.png`;
};

export default mapTileProvider;
